import React from 'react';
import { useDialogs } from 'src/hooks/useDialogs';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { CreateCostCodeForm } from './CreateCostCodeForm';

/** @registry Modal for creating/updating a cost code. */
export const CreateCostCodeDialog: React.FC = () => {
  const {
    createCostCodeDialogOpen,
    setCreateCostCodeDialogOpen,
    selectedCostCode,
  } = useDialogs();

  return (
    <BaseModal
      opened={createCostCodeDialogOpen}
      onClose={() => setCreateCostCodeDialogOpen(false)}
      title={selectedCostCode ? 'Update Cost Code' : 'Add Cost Code'}
      size="md"
      centered
    >
      <CreateCostCodeForm
        selectedCostCode={selectedCostCode}
        setCreateCostCodeDialogOpen={setCreateCostCodeDialogOpen}
      />
    </BaseModal>
  );
};
